module.exports = __webpack_public_path__ + "img/materials-and-equipments.61b87e01.svg";